import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'antd';
import { Link } from 'dva/router';
import { FormattedMessage } from 'react-intl';
import styles from './styles.less';

export const PageHeader = ({ children, onBackToOverview, backText, buttons }) => {
  const msgId = backText || 'Common.BackToOverview';
  const backContent = <FormattedMessage id={msgId} />;

  return (
    <Row type="flex" align="middle" className="pageHeader">
      <Col xxl={8} xl={8} lg={24} md={24} sm={24}>
        <h2 className={styles.pageTitle}>{children}</h2>
      </Col>
      {onBackToOverview ?
        <Col className={styles.btnWrap} xxl={16} xl={16} lg={24} md={24} sm={24}>
          <Row type="flex" justify="end">
            {buttons}
            {
              typeof onBackToOverview === 'function' ?
                <Button
                  type="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    onBackToOverview();
                  }}
                >
                  {backContent}
                </Button>
                :
                <Link to={onBackToOverview} className={styles.btnNoBorder}>
                  {backContent}
                </Link>
            }
          </Row>
        </Col>
        : null}
    </Row>
  );
};

PageHeader.propTypes = {
  onBackToOverview: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.func,
  ]),
};



// WEBPACK FOOTER //
// ./src/components/PageHeader/PageHeader.js